/**
 * Helper function to check if a term has valid customer cash
 * @param {Object} term - The term object to check
 * @returns {boolean} - True if term has valid customer cash value
 */
const hasValidCustomerCash = term => typeof term.customerCash === 'number' && term.customerCash > 0;

/**
 * Helper function to check if an incentive has any cash value
 * @param {Object} incentive - The incentive object to check
 * @returns {boolean} - True if the incentive has any cash value
 */
const hasIncentiveCashValue = incentive => {
  const hasTopLevelCash = typeof incentive.cash === 'number' && incentive.cash > 0;
  if (hasTopLevelCash) {
    return true;
  }
  const termRebates = incentive.termRebates?.incentiveTermRange;
  if (!termRebates) {
    return false;
  }
  return termRebates.some(hasValidCustomerCash);
};
export { hasIncentiveCashValue as default };
